<template lang="html">
  <div class="cs-hero">
    <main-header></main-header>
    <section class="cs-hero__bg">
      <slot name="hero-image"></slot>
    </section>
  </div>
</template>

<script>
  import Header from '@/components/Header'

  export default {
    components: {
      'main-header': Header
    },
    name: 'cs-hero',
    props: {
      image: String,
      alt: String
    },
    data () {
      return {

      }
    }
  }
</script>

<style lang='scss'>
  // Import global settings file per component.
  @import 'src/assets/scss/settings.scss';

  .cs-hero {
    display: grid;
    grid-template-columns: 100%;
    grid-template-rows: 75px auto;

    height: calc(100vh - 7.500rem);
    width: 100%;

    @include breakpoint($md) {
      grid-template-rows: 120px auto;
    }
  }

  .cs-hero__bg {
    grid-column: 1 / 2;
    grid-row: 1 / 3;

    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: center;
    text-align: center;
    img {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: calc(100% - 7.500rem);
      object-fit: cover;
      object-position: 50% 50%;
      vertical-align: middle;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/CsHero.vue